import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Backdrop } from '@material-ui/core';
import { BackdropStyles } from '../styles/fullPageLoader';
import useHiddenHeaderFooter from '../../survey/hooks/useHiddenHeaderFooter';

/** Props for FullPageLoader component */
interface FullPageLoaderProps {
  isLoading?: boolean;
  backdropColor?: string;
  customClass?: string;
}

/** Compoeent for showing loading icon with backdrop in page center */
export const FullPageLoader = (props: FullPageLoaderProps): JSX.Element => {
  const { backdropColor, isLoading } = props;
  const classes = BackdropStyles({ backdropColor });
  useHiddenHeaderFooter(props.customClass || '');
  return (
    <>
      {isLoading && (
        <Backdrop className={classes.backdropBgColor} open={isLoading}>
          <CircularProgress color="primary" />
        </Backdrop>
      )}
    </>
  );
};
